import {Grid, List, ListItem} from '@material-ui/core';
import {Cancel, CheckCircle, ChevronRight} from '@material-ui/icons';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import {pushRoute} from '../../../routes';
import {IPlate, PlateVoteStatusEnum} from '../store/types';

interface IProps {
  elections: IPlate[];
  className?: string;
  restrain?: boolean;
}

const PlateVoted: React.FC = () => {
  const {t} = useTranslation();

  return (
    <Grid
      className={`election-status status-voted`}
      container={true}
      direction="row"
      justify="flex-end"
      alignItems="center"
    >
      <small>{t('lista-eleicoes.voto-registrado')}</small>
      <CheckCircle />
    </Grid>
  );
};

const PlateOpen: React.FC = () => {
  const {t} = useTranslation();

  return (
    <Grid
      className={`election-status status-open`}
      container={true}
      direction="row"
      justify="flex-end"
      alignItems="center"
    >
      <span>{t('lista-eleicoes.votar')}</span>
      <ChevronRight />
    </Grid>
  );
};

const PlateUndo: React.FC = () => {
  const {t} = useTranslation();

  return (
    <Grid
      className={`election-status status-not-voted`}
      container={true}
      direction="row"
      justify="flex-end"
      alignItems="center"
    >
      <small>{t('lista-eleicoes.nao-votou')}</small>
      <Cancel />
    </Grid>
  );
};

const ListElection: React.FC<IProps> = ({elections, className, restrain}) => {
  const dispatch = useDispatch();

  const getLabelStatus = (value: IPlate) => {
    switch (value.status) {
      case PlateVoteStatusEnum.VOTED:
        return <PlateVoted />;

      case PlateVoteStatusEnum.OPEN:
        return <PlateOpen />;

      case PlateVoteStatusEnum.UNDO:
        return <PlateUndo />;
    }
  };

  const goToPlateDetail = (value: IPlate) => () => {
    if (!restrain) {
      dispatch(pushRoute('election', value.uuid));
    }
  };

  return (
    <List
      component="nav"
      className={`list-white ${className}`}
      aria-label="eleições"
    >
      {elections.map(value => {
        return (
          <ListItem
            key={value.id}
            role={undefined}
            dense={true}
            button={true}
            onClick={goToPlateDetail(value)}
            selected={restrain}
            disabled={restrain}
          >
            <Grid container={true}>
              <Grid
                direction="column"
                container={true}
                item={true}
                xs={7}
                className="identification"
              >
                <span>{value.name}</span>
                <small className="secondary-text font-size-13">
                  {value.description}
                </small>
              </Grid>
              <Grid item={true} xs={5}>
                {getLabelStatus(value)}
              </Grid>
            </Grid>
          </ListItem>
        );
      })}
    </List>
  );
};

export default ListElection;



// WEBPACK FOOTER //
// ./src/features/election/components/ListElection.tsx